import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getAccountsListAndAvailableBalance } from '../../utilities/account-utils';
import { Link } from 'react-router-dom'
import { formatCurrency } from '../../utilities/general-utils'
import styles from './ActiveFundsWidget.module.css';

const ActiveFundsWidget = () => {
    const [ accountsData, setAccountsData ] = useState(null);
    const { getAccessTokenSilently, user } = useAuth0();

    const getAccountsData = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getAccountsListAndAvailableBalance(accessToken, user.sub);

        if (error) {
            console.error("Error getting available balance: ", error);
            return;
        }

        setAccountsData(data);
    }

    useEffect(() => {
        if (!accountsData) {
            getAccountsData();
        }
    }, [accountsData]);

    if (!accountsData) {
        return null
    }

    if (accountsData.accountsList === null && accountsData.availableBalance === null) {
        return (
            <div className="text-center spc-p-1">
                <Link className="button button-green" to="/add-account">
                    Add an account
                </Link>
                <p className="spc-m-t-1" style={{fontSize: ".9rem", fontWeight: '300'}}>
                    If you've already <Link to="/accounts">added an account</Link>, make sure the box is checked to "include balance" if you want to see your available balance here.
                </p>
            </div>
        )
    }

    if (accountsData.accountsList && accountsData.availableBalance) {
        return (
            <div className={`formField ${styles.ActiveFundsWidget}`}>
                <label>
                    <span style={{lineHeight: '1', display: 'inline-block', verticalAlign: 'middle', marginRight: '.5rem'}}>Starting Balance</span>
                    <Link style={{fontSize: '80%', fontWeight: 200, textDecoration: 'none'}} to="/accounts?included=true">{accountsData.accountsList.length} account(s)</Link>
                    <p className={styles.ActiveFunds}>
                        {formatCurrency(accountsData.availableBalance)}
                    </p>
                </label>
            </div>
        )
    }

    return null
}

export default ActiveFundsWidget